import React, { PureComponent } from "react";

import electricBassAndSinging from "./img/electric-bass-and-singing.jpg";
import electricBassAndSinging2 from "./img/electric-bass-and-singing-2.jpg";

import upright from "./img/upright.jpg";

class PicsPage extends PureComponent {
  render() {
    const style = {
      width: "100%",
      height: "auto",
      maxWidth: "100%"
    };

    const alt = "Pic Mark Allan";

    return (
      <div>
        <h1>Pics</h1>

        <hr />

        <div>
          <img style={style} alt={alt} src={electricBassAndSinging} />
        </div>

        <div>
          <img style={style} alt={alt} src={upright} />
        </div>

        <div>
          <img style={style} alt={alt} src={electricBassAndSinging2} />
        </div>
      </div>
    );
  }
}

export default PicsPage;



// WEBPACK FOOTER //
// ./src/routes/pics/PicsPage.js